module.exports = __webpack_public_path__ + "img/default_img.a9d28854.jpg";